module.exports = __webpack_public_path__ + "static/media/ic_trusted_red.5872d643.svg";